import { ConfigProvider } from "antd"
import ACLProvider from "contexts/ACL/Provider"
import I18nProvider, { baseTFunction } from "contexts/I18n/I18nProvider"
import authService from 'core/auth/auth-service'
import { ACCESS_TOKEN_KEY } from 'core/auth/constants'
import ErrorPage from "core/error-page"
import i18nInitialize, { getLanguage, loadI18n } from "core/i18n/i18n"
import getRouter from "core/router"
import SpinnerComponent from "core/spinner/spinner-component"
import LocalSignIn from 'modules/login/local'
import { useEffect, useState } from "react"
import { Provider as ReduxProvider } from 'react-redux'
import { RouterProvider } from "react-router-dom"
import { envs, initializeEnvs } from "./envHandler"
import store from './redux'

export default function ApplicationWrapper() {
  const currentUser = authService.getCurrentUser()  

  const [envsSet, setEnvsSet] = useState(false)
  const [tFunction, setTFunction] = useState(() => baseTFunction)
  const [envsLoading, setEnvsLoading] = useState(true)
  const [tFunctionLoading, setTFunctionLoading] = useState(true)

  useEffect(() => {
    const fetchEnvs = async () => {
      setEnvsLoading(true)

      const envsSuccessfullyInitialized = await initializeEnvs()

      setEnvsSet(envsSuccessfullyInitialized)
      setEnvsLoading(false)
    }

    fetchEnvs()
  }, [])

  useEffect(() => {
    const initializeI18n = async () => {
      const currentLanguage = getLanguage(authService.getCurrentLanguage())
      const t = await i18nInitialize(
        `${envs.REACT_APP_API_URL}/translations/${currentLanguage}`,
        currentLanguage,
      )

      store.dispatch(loadI18n(t))
      setTFunction(() => t)
      setTFunctionLoading(false)
    }

    if (!envs.REACT_APP_API_URL || !tFunctionLoading) {
      return
    }
    if (localStorage.getItem(ACCESS_TOKEN_KEY)) {
      initializeI18n()
    } else {
      setTFunctionLoading(false)
    }
  }, [tFunctionLoading, envs.REACT_APP_API_URL])

  if (envsLoading) {
    return <SpinnerComponent isActive />
  }

  if(!envsSet) {
    return <ErrorPage />
  }

  if(envs.REACT_APP_IS_LOCAL && !currentUser.token) {
    return <LocalSignIn />
  }

  if(!envs.REACT_APP_IS_LOCAL && !localStorage.getItem(ACCESS_TOKEN_KEY) && !window.location.pathname.startsWith('/login')) {
    authService.redirectLogout()
    return <SpinnerComponent isActive />
  }

  if (tFunctionLoading) {
    return <SpinnerComponent isActive />
  }

  return (
    <ReduxProvider store={store}>
      <ConfigProvider theme={{
        token:{
          colorPrimary: "#e60000"
        }
      }}>     
      <ACLProvider>
        <I18nProvider t={tFunction}>
          <RouterProvider router={getRouter()}/>
        </I18nProvider>
      </ACLProvider>
      </ConfigProvider>
    </ReduxProvider>
  )
}
